// Central auth helpers — single point that reads/writes the Sanctum token,
// user id, role, and language. If we ever move off localStorage (e.g. to
// sessionStorage or an httpOnly cookie via Sanctum SPA mode), only this
// file changes.

const TOKEN_KEY = "token";
const USER_ID_KEY = "user_id";
const ROLE_ID_KEY = "role_id";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);

export const getUserId = () => localStorage.getItem(USER_ID_KEY);
export const getRoleId = () => localStorage.getItem(ROLE_ID_KEY);
export const isSuperuser = () => String(getRoleId()) === "1";

export const setAuth = ({ token, userId, roleId }) => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    if (userId !== undefined && userId !== null) localStorage.setItem(USER_ID_KEY, userId);
    if (roleId !== undefined && roleId !== null) localStorage.setItem(ROLE_ID_KEY, roleId);
};

export const clearAuth = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_ID_KEY);
    localStorage.removeItem(ROLE_ID_KEY);
    localStorage.removeItem("index");
};

export const isAuthenticated = () => Boolean(getToken());

// Subscribers for forced logout (used by the axios interceptor to nudge
// React to re-render after a 401).
const listeners = new Set();
export const onAuthExpired = (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
};
export const emitAuthExpired = () => {
    clearAuth();
    listeners.forEach((fn) => {
        try { fn(); } catch (_) { /* ignore */ }
    });
};